import { useMutation } from "react-query";
import http from "infra/http";

function useCheckinParticipante({
  votacaoId,
  pessoaId,
  unidades,
}: {
  votacaoId: string;
  pessoaId: string;
  unidades: string[];
}) {
  return useMutation(
    (votoDigital: boolean) => {
      return http.post(`/v1/votacao/${votacaoId}/participantes/checkin`, {
        pessoaId,
        unidades,
        votoDigital,
      });
    },
    { retry: false }
  );
}

export default useCheckinParticipante;
